export const addDefaultOutlineEffect = (element: HTMLElement) => {
  const hadTabIndex = element.hasAttribute('tabindex');
  if (!hadTabIndex) {
    element.setAttribute('tabindex', '0');
  }

  const originalInlineOutline = element.style.outline;
  const originalInlineOutlineOffset = element.style.outlineOffset;

  // Focus without causing an additional scroll jump
  element.focus({ preventScroll: true });

  // If styles elsewhere have removed outlines, ensure the browser default is visible
  const computed = window.getComputedStyle(element);
  const outlineIsMissing =
    computed.outlineStyle === 'none' || computed.outlineWidth === '0px';
  if (outlineIsMissing) {
    element.style.outline = 'auto';
    element.style.outlineOffset = '2px';
  }

  const cleanup = () => {
    if (outlineIsMissing) {
      element.style.outline = originalInlineOutline;
      if (originalInlineOutlineOffset) {
        element.style.outlineOffset = originalInlineOutlineOffset;
      } else {
        element.style.removeProperty('outline-offset');
      }
    }
    element.removeEventListener('blur', cleanup);
  };

  element.addEventListener('blur', cleanup);
};

